import {
  TextStandardSettings,
  LongTextStandardSettings,
} from 'apps/studio/components/settings/fields/Text/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { ReferenceDataPanel } from 'apps/studio/components/settings/fields/Base/referenceData'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { TextAdvancedSettings, LongTextAdvancedSettings } from 'apps/studio/components/settings/fields/Text/advanced'

export const TextSettings = [
  FieldSettingsPanel(TextStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  TextAdvancedSettings
]

export const LongTextSettings = [
  FieldSettingsPanel(LongTextStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ReferenceDataPanel,
  // ConditionsPanel,
  LongTextAdvancedSettings
]
